module.exports = __webpack_public_path__ + "img/Big_data.ca83f9af.jpg";